import { render, staticRenderFns } from "./FullRank.vue?vue&type=template&id=f44674da&scoped=true&"
import script from "./FullRank.vue?vue&type=script&lang=js&"
export * from "./FullRank.vue?vue&type=script&lang=js&"
import style0 from "./FullRank.vue?vue&type=style&index=0&id=f44674da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f44674da",
  null
  
)

export default component.exports